import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'

export const scanAndPayAccessControl: DomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.ScanAndPay],
}

export const scanAndPayOrderRefundAccessControl: DomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.ScanAndPayOrderRefund],
}
